// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Import the functions you need from the SDKs you need


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
      
      apiKey: "AIzaSyBhcrGZN_j3XEwwbw2YcFSwAMSfMHVhchA",
      authDomain: "web-dev-2d1b0.firebaseapp.com",
      projectId: "web-dev-2d1b0",
      storageBucket: "web-dev-2d1b0.firebasestorage.app",
      messagingSenderId: "934318641121",
      appId: "1:934318641121:web:d6e4450449709e7c15cca0",
      measurementId: "G-7J9CEYFF1X"
      
  };


// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);